import { Component, OnInit, ViewChild } from '@angular/core';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { Models } from '@ibexfusion/models';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { OrganisationService } from '@services/organisations/organisation.service';
import { RoleService } from '@services/roles/role.service';
import { GroupHasRoleInOrganisationService } from '@services/groups/group-has-role-in-organisation.service';
import { DataTableComponent, DataTableEvent } from '../../../components/data-table/data-table.component';
import { OrganisationCustomerService } from '@services/customers/organisation-customer.service';

@Component({
    selector: 'app-organisation-detail',
    templateUrl: './organisation-detail.component.html',
    styleUrls: ['./organisation-detail.component.scss'],
    providers: [OrganisationService, RoleService, GroupHasRoleInOrganisationService, OrganisationCustomerService],
    standalone: false
})
export class OrganisationDetailComponent implements OnInit {

  @ViewChild('assigned') assignedTable: DataTableComponent;

  public title = 'Organisation: ';

  public columns = [
    { prop: 'name' }, { prop: 'desc' }
  ];

  isLoading = false;

  pageActions: PageAction[];

  organisationId = null;
  boundOrganisation: Models.Organisation;

  roles = [];
  groups = [];
  parentOrganisation = null;
  organisationCustomer = null;

  constructor(
    private route: ActivatedRoute,
    public organisationService: OrganisationService,
    public roleService: RoleService,
    public ghrOrgService: GroupHasRoleInOrganisationService,
    public organisationCustomerService: OrganisationCustomerService,
    private snackbar: SnackbarService,
    private router: Router
  ) {
    this.route.params.subscribe(params => {
      this.organisationId = this.route.snapshot.params['id'];
      this.reset(); // if we route to the parentOrganisation trigger reload
      this.initialize();
    });
  }

  ngOnInit() {
  }

  initialize() {
    this.createPageAction();
    this.isLoading = true;
    if (this.organisationId) {
      this.organisationService.get(this.organisationId).then(result => {
        this.boundOrganisation = result;
        this.title += this.boundOrganisation.title;
        this.getGroupAndRole();
        if (this.boundOrganisation.ParentOrganisationID) {
          this.getParentOrganisation();
        }
        if (this.boundOrganisation.organisationCustomerId) {
          this.getOrganisationCustomer();
        }
        this.isLoading = false;
      });
    }
  }

  reset() {
    this.pageActions = [];
    this.boundOrganisation = null;
    this.roles = [];
    this.groups = [];
    this.parentOrganisation = null;
    this.organisationCustomer = null;
  }

  createPageAction() {
    this.pageActions = [
      new PageAction({
        icon: 'edit',
        title: 'edit organisation',
        callback: () => {
          this.router.navigate(['organisations', this.organisationId, 'edit'])
        }
      })
    ]
  }

  getGroupAndRole() {
    this.ghrOrgService.find(0, 100, { OrganisationID: this.organisationId }).then(result => {
      if (result.data && result.data.length) {
        result.data.map(item => {
          this.roles.push({ RoleID: item.RoleID, name: item.roleName, desc: item.groupDescription });
          this.groups.push({ GroupID: item.GroupID, name: item.groupName, desc: item.roleDescription });
        });
      }
    });
  }

  getOrganisationCustomer() {
    this.organisationCustomerService.get(this.boundOrganisation.organisationCustomerId).then(result => {
      this.organisationCustomer = result;
    })
  }

  getParentOrganisation() {
    this.organisationService.find(0, 1, { OrganisationID: this.boundOrganisation.ParentOrganisationID }).then(result => {
      this.parentOrganisation = result && result.data && result.data.length ? result.data[0] : null;
    })
  }

  public goToGroup(event: DataTableEvent) {
    this.router.navigate(['groups', event.row.GroupID]);
  }

  public goToRole(event: DataTableEvent) {
    this.router.navigate(['roles', event.row.RoleID]);
  }

  public goToParentOrganisation(event: DataTableEvent) {
    this.router.navigate(['organisations', event.row.OrganisationID]).then(() => {
    });
  }

  public goToOrganisationCustomer(event: DataTableEvent) {
    this.router.navigate(['organisation-customers', event.row._id]);
  }
}
